/* Internal dependencies */
import { PaginationOptions } from '../types/Pagination';
import { cleanObject } from '../common/cleanObject';
import API from '.';

export const listChartCollectionsForItem = async (itemId: string, options: PaginationOptions) =>
  await API.get({
    path: '/charts/collections',
    options: {
      queryParams: cleanObject({
        itemId,
        ...options,
      }),
    },
  });